(function () {
  if (window.__fbpHeadAddonDiscountLoaded) return;
  window.__fbpHeadAddonDiscountLoaded = true;

  var WELCOME_COVER_CODE = 'WELCOMECOVER';
  var WELCOME_COVER_AUTO_APPLY_KEY = 'fbp_welcome_cover_auto_apply_attempted';
  var WELCOME_COVER_TIMEOUT_MS = 8000;
  var welcomeCoverMapPromise = null;
  var welcomeCoverSubmitInFlight = false;
  var welcomeCoverAutoApplyInFlight = false;
  var welcomeCoverAutoApplyTimer = null;
  var welcomeCoverAutoApplyAttempted = false;

  function checkoutButtonFromEvent(event) {
    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout') return submitter;

    var active = document.activeElement;
    if (active && active.name === 'checkout') return active;

    return null;
  }

  function isAddonDiscountForm(form) {
    return Boolean(form && form.matches('[data-fbp-addon-discount-form]'));
  }

  function discountIsActive(form, attribute) {
    return form && form.getAttribute(attribute) === 'true';
  }

  function discountCodeForAttribute(form, attribute) {
    return String((form && form.getAttribute(attribute)) || '').trim();
  }

  function manualDiscountCodeForForm(form) {
    var input = form && form.querySelector('[name="discount"]');
    return String((input && input.value) || '').trim();
  }

  function normalizeDiscountCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function compactDiscountCode(code) {
    return normalizeDiscountCode(code).replace(/[^A-Z0-9]/g, '');
  }

  function sessionStorageGet(key) {
    try {
      return window.sessionStorage && window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function sessionStorageSet(key, value) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Session storage can be unavailable in some privacy modes.
    }
  }

  function isWelcomeCoverCode(code) {
    return compactDiscountCode(code) === WELCOME_COVER_CODE;
  }

  function canonicalDiscountCode(code) {
    var trimmed = String(code || '').trim();
    return isWelcomeCoverCode(trimmed) ? WELCOME_COVER_CODE : trimmed;
  }

  function dedupeDiscountCodes(codes) {
    return codes.map(canonicalDiscountCode).filter(Boolean).filter(function (code, index, list) {
      var normalized = normalizeDiscountCode(code);
      return list.findIndex(function (entry) {
        return normalizeDiscountCode(entry) === normalized;
      }) === index;
    });
  }

  function hasDiscountCode(codes, code) {
    var normalized = normalizeDiscountCode(code);
    if (normalized === WELCOME_COVER_CODE) {
      return codes.some(function (entry) {
        return isWelcomeCoverCode(entry);
      });
    }
    return codes.some(function (entry) {
      return normalizeDiscountCode(entry) === normalized;
    });
  }

  function discountCodeFromVisibleText(text) {
    var value = String(text || '').replace(/\s+/g, ' ').trim();
    if (!value) return '';
    if (isWelcomeCoverCode(value)) return WELCOME_COVER_CODE;

    value = value.replace(/\s*\(-?[$\u20ac\u00a3][^)]+\)\s*$/g, '').trim();
    if (!value || isWelcomeCoverCode(value)) return isWelcomeCoverCode(value) ? WELCOME_COVER_CODE : '';

    var lower = value.toLowerCase();
    if (lower.indexOf('welcome cover gift') === 0) return '';
    if (lower.indexOf('matching head pillow') === 0) return '';
    if (lower.indexOf('design of the week') === 0) return '';
    if (/[\u20ac\u00a3$]/.test(value)) return '';
    if (value.length > 80) return '';
    if (!/[a-z0-9]/i.test(value)) return '';

    return value;
  }

  function visibleDiscountCodesForForm(form) {
    var root = form && (form.closest('section.cart-page') || form.closest('ajax-cart') || form.closest('.mini-cart') || form);
    var nodes = (root || document).querySelectorAll('.discounts__discount');
    return Array.prototype.map.call(nodes, function (node) {
      return discountCodeFromVisibleText(node.textContent);
    });
  }

  function activeDiscountCodesForForm(form) {
    var codes = visibleDiscountCodesForForm(form);

    if (discountIsActive(form, 'data-fbp-addon-discount-active')) {
      codes.push(discountCodeForAttribute(form, 'data-fbp-addon-discount-code'));
    }

    codes.push(manualDiscountCodeForForm(form));

    return dedupeDiscountCodes(codes);
  }

  function cartDiscountCodes(cart) {
    var codes = [];
    var items = (cart && cart.items) || [];

    items.forEach(function (item) {
      ((item && item.discounts) || []).forEach(function (discount) {
        codes.push(discountCodeFromVisibleText(discount && (discount.title || discount.code)));
      });
    });

    ((cart && cart.cart_level_discount_applications) || []).forEach(function (discount) {
      codes.push(discountCodeFromVisibleText(discount && (discount.title || discount.code)));
    });

    ((cart && cart.discount_applications) || []).forEach(function (discount) {
      codes.push(discountCodeFromVisibleText(discount && (discount.title || discount.code)));
    });

    return dedupeDiscountCodes(codes);
  }

  function mergeDiscountCodes(primaryCodes, secondaryCodes) {
    return dedupeDiscountCodes((primaryCodes || []).concat(secondaryCodes || [])).map(function (code) {
      return isWelcomeCoverCode(code) ? WELCOME_COVER_CODE : code;
    });
  }

  function checkoutDiscountUrl(codes) {
    return discountRedirectUrl(codes, '/checkout');
  }

  function cartDiscountUrl(codes, welcomeCoverAdded) {
    return discountRedirectUrl(codes, welcomeCoverAdded ? '/cart?fbp_welcome_cover=added' : '/cart');
  }

  function discountRedirectUrl(codes, redirectPath) {
    var codePath = codes.map(encodeURIComponent).join(',');
    return '/discount/' + codePath + '?redirect=' + encodeURIComponent(redirectPath);
  }

  function rootUrl() {
    var routes = window.Shopify && window.Shopify.routes;
    return (routes && routes.root) || '/';
  }

  function assetMapUrl() {
    var script = document.currentScript;
    var configuredScript = document.querySelector('script[src*="fbp-head-addon-discount.js"][data-fbp-daki-head-map-url]');
    if (!script || !script.getAttribute('data-fbp-daki-head-map-url')) {
      script = configuredScript || script || document.querySelector('script[src*="fbp-head-addon-discount.js"]');
    }
    var dataUrl = script && script.getAttribute('data-fbp-daki-head-map-url');
    if (dataUrl) return dataUrl;
    var src = script && script.getAttribute('src');
    if (src) return src.replace(/fbp-head-addon-discount(?:\.[a-z0-9]+)?\.js(?:\?.*)?$/i, 'fbp-daki-head-addon-map.json');
    return rootUrl() + 'assets/fbp-daki-head-addon-map.json';
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('request_failed_' + response.status);
      return response.json();
    });
  }

  function loadWelcomeCoverMap() {
    if (!welcomeCoverMapPromise) {
      var pending = fetchJson(assetMapUrl(), {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      welcomeCoverMapPromise = pending;
      pending.catch(function () {
        if (welcomeCoverMapPromise === pending) welcomeCoverMapPromise = null;
      });
    }
    return welcomeCoverMapPromise;
  }

  function fetchCart() {
    return fetchJson(rootUrl() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
  }

  function cartItemHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    if (item.product_handle) return String(item.product_handle);
    var url = String(item.url || '');
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function normalizeSizeLabel(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '').replace(/"/g, '');
  }

  function matchingFortyCoverVariant(product) {
    var variants = (product && product.variants) || [];
    return variants.find(function (variant) {
      var size = normalizeSizeLabel(variant.size || variant.title);
      return variant.available !== false && (size === '40x40cm' || size === 'eu40x40cm');
    }) || null;
  }

  function cartLineProperties(item) {
    return (item && item.properties && typeof item.properties === 'object') ? item.properties : {};
  }

  function cartAlreadyHasWelcomeCover(cart, parentHandle, variantId) {
    var normalizedVariantId = String(variantId || '');
    return ((cart && cart.items) || []).some(function (item) {
      var properties = cartLineProperties(item);
      var sameVariant = String(item.variant_id || item.id || '') === normalizedVariantId;
      var taggedForParent = String(properties._fbp_welcome_cover_parent_handle || '') === parentHandle;
      return taggedForParent || (sameVariant && String(properties._fbp_welcome_cover || '') === 'true') || sameVariant;
    });
  }

  function cartHasPotentialDaki(cart) {
    return ((cart && cart.items) || []).some(function (item) {
      var handle = cartItemHandle(item).toLowerCase();
      var title = String((item && (item.product_title || item.title)) || '').toLowerCase();
      return handle.indexOf('dakimakura') !== -1 || title.indexOf('dakimakura') !== -1 || title.indexOf('body pillow') !== -1;
    });
  }

  function cartHasWelcomeCoverLine(cart) {
    return ((cart && cart.items) || []).some(function (item) {
      var properties = cartLineProperties(item);
      return String(properties._fbp_welcome_cover || '') === 'true' || isWelcomeCoverCode(properties._fbp_welcome_cover_code);
    });
  }

  function welcomeCoverSelection(cart, map) {
    var productsByDakiHandle = (map && map.productsByDakiHandle) || {};
    var firstAlreadyInCart = null;
    var items = (cart && cart.items) || [];

    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      var dakiHandle = cartItemHandle(item);
      var coverProduct = dakiHandle && productsByDakiHandle[dakiHandle];
      if (!coverProduct) continue;

      var coverVariant = matchingFortyCoverVariant(coverProduct);
      if (!coverVariant) continue;

      var selection = {
        parentItem: item,
        parentHandle: dakiHandle,
        parentTitle: item.product_title || item.title || coverProduct.title || 'Body pillow cover',
        coverProduct: coverProduct,
        coverVariant: coverVariant
      };

      if (!cartAlreadyHasWelcomeCover(cart, dakiHandle, coverVariant.id)) return selection;
      if (!firstAlreadyInCart) firstAlreadyInCart = selection;
    }

    return firstAlreadyInCart;
  }

  function addWelcomeCover(selection) {
    var variantId = Number(selection.coverVariant.id);
    if (!Number.isFinite(variantId) || variantId <= 0) throw new Error('missing_cover_variant');

    return fetchJson(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_fbp_welcome_cover': 'true',
            '_fbp_welcome_cover_code': WELCOME_COVER_CODE,
            '_fbp_welcome_cover_parent_handle': selection.parentHandle,
            '_fbp_welcome_cover_parent_title': selection.parentTitle,
            'Welcome gift for': selection.parentTitle,
            'Welcome gift size': selection.coverVariant.size || selection.coverVariant.title || '40x40cm'
          }
        }]
      })
    });
  }

  function cartHasWelcomeCoverSelection(cart, selection) {
    return Boolean(selection && cartAlreadyHasWelcomeCover(cart, selection.parentHandle, selection.coverVariant && selection.coverVariant.id));
  }

  function waitForWelcomeCoverInCart(selection) {
    var attempts = 0;

    function checkCart() {
      return fetchCart().then(function (cart) {
        if (cartHasWelcomeCoverSelection(cart, selection)) return cart;
        attempts += 1;
        if (attempts >= 4) throw new Error('welcome_cover_add_unconfirmed');
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 300);
        }).then(checkCart);
      });
    }

    return checkCart();
  }

  function statusNodeForForm(form) {
    if (!form) return null;
    var node = form.querySelector('[data-fbp-welcome-cover-status]');
    if (node) return node;

    var discountContent = form.querySelector('.discount-content') || form;
    node = document.createElement('p');
    node.className = 'fbp-welcome-cover-status';
    node.setAttribute('data-fbp-welcome-cover-status', '');
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    node.hidden = true;
    discountContent.appendChild(node);
    return node;
  }

  function setWelcomeCoverStatus(form, type, message) {
    var node = statusNodeForForm(form);
    if (!node) return;
    node.hidden = !message;
    node.textContent = message || '';
    node.setAttribute('data-state', type || 'info');
  }

  function setCheckoutBusy(button, busy) {
    if (!button) return;
    if (busy) {
      if (!button.getAttribute('data-fbp-original-text')) {
        button.setAttribute('data-fbp-original-text', button.textContent);
      }
      button.disabled = true;
      button.classList.add('fbp-welcome-cover-busy');
      button.textContent = 'Adding free cover...';
      return;
    }

    button.disabled = false;
    button.classList.remove('fbp-welcome-cover-busy');
    var originalText = button.getAttribute('data-fbp-original-text');
    if (originalText) button.textContent = originalText;
  }

  function setApplyBusy(target, busy) {
    if (!target) return;
    target.setAttribute('aria-busy', busy ? 'true' : 'false');
    target.classList.toggle('fbp-welcome-cover-busy', Boolean(busy));
  }

  // One destination owns this document. Checkout supersedes pending Apply/auto
  // preparation; repeated clicks and stale continuations cannot navigate again.
  var welcomeCoverNavigationIntent = null;
  function beginWelcomeCoverNavigation(kind) {
    var current = welcomeCoverNavigationIntent;
    if (current && (current.committed || current.kind === 'checkout')) return null;
    if (current && kind !== 'checkout' && (kind === 'auto' || current.kind === 'apply')) return null;
    var intent = { kind: kind, committed: false };
    welcomeCoverNavigationIntent = intent;
    return intent;
  }
  function ownsWelcomeCoverNavigation(intent) {
    return Boolean(intent && welcomeCoverNavigationIntent === intent && !intent.committed);
  }
  function releaseWelcomeCoverNavigation(intent) {
    if (ownsWelcomeCoverNavigation(intent)) welcomeCoverNavigationIntent = null;
  }
  function navigateWelcomeCover(intent, url) {
    if (!ownsWelcomeCoverNavigation(intent)) return false;
    intent.committed = true;
    window.location.href = url;
    return true;
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    welcomeCoverNavigationIntent = null;
    welcomeCoverSubmitInFlight = false;
    welcomeCoverAutoApplyInFlight = false;
    document.querySelectorAll('[name="checkout"].fbp-welcome-cover-busy').forEach(function (button) {
      if (isAddonDiscountForm(button.form)) setCheckoutBusy(button, false);
    });
    document.querySelectorAll('[data-fbp-addon-discount-form] [aria-busy="true"].fbp-welcome-cover-busy').forEach(function (target) {
      setApplyBusy(target, false);
    });
  });

  function withTimeout(promise, timeoutMs, code) {
    return new Promise(function (resolve, reject) {
      var finished = false;
      var timer = window.setTimeout(function () {
        if (finished) return;
        finished = true;
        reject(new Error(code || 'timeout'));
      }, timeoutMs);

      Promise.resolve(promise).then(function (value) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        resolve(value);
      }).catch(function (error) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        reject(error);
      });
    });
  }

  function applyDiscountFromCartControl(form, target) {
    var manualCode = canonicalDiscountCode(manualDiscountCodeForForm(form));
    var codes = activeDiscountCodesForForm(form);
    if (!manualCode && !codes.length) {
      setWelcomeCoverStatus(form, 'error', 'Enter your discount code first.');
      return;
    }

    var navigation = beginWelcomeCoverNavigation('apply');
    if (!navigation) return;
    setApplyBusy(target, true);

    if (!isWelcomeCoverCode(manualCode)) {
      navigateWelcomeCover(navigation, cartDiscountUrl(manualCode ? [manualCode] : codes));
      return;
    }

    prepareWelcomeCoverGift(form).then(function (selection) {
      navigateWelcomeCover(navigation, cartDiscountUrl([WELCOME_COVER_CODE], true));
    }).catch(function (error) {
      setApplyBusy(target, false);
      if (!ownsWelcomeCoverNavigation(navigation)) return;
      releaseWelcomeCoverNavigation(navigation);
      setWelcomeCoverStatus(form, 'error', welcomeCoverErrorMessage(error));
    });
  }

  // Manual Apply, automatic preparation and checkout share one in-flight add.
  // Keep this pending until the underlying request settles, even if a caller times out.
  var welcomeCoverPreparation = null;
  function prepareWelcomeCoverGift(form) {
    if (welcomeCoverPreparation) return welcomeCoverPreparation;
    var pending = Promise.resolve().then(function () {
      return performWelcomeCoverPreparation(form);
    });
    welcomeCoverPreparation = pending;
    var clear = function () {
      if (welcomeCoverPreparation === pending) welcomeCoverPreparation = null;
    };
    pending.then(clear, clear);
    return pending;
  }

  function performWelcomeCoverPreparation(form) {
    var statusNavigation = welcomeCoverNavigationIntent;
    function setPreparationStatus(type, message) {
      if (welcomeCoverNavigationIntent !== statusNavigation || (statusNavigation && statusNavigation.failed)) return;
      setWelcomeCoverStatus(form, type, message);
    }
    setPreparationStatus('info', 'Checking your cart for the matching free 40x40 cover...');
    return Promise.all([fetchCart(), loadWelcomeCoverMap()]).then(function (results) {
      var cart = results[0];
      var map = results[1];
      var selection = welcomeCoverSelection(cart, map);
      if (!selection) {
        if (cartHasPotentialDaki(cart)) throw new Error('missing_cover_variant');
        throw new Error('welcome_cover_needs_body_pillow');
      }

      selection.existingDiscountCodes = cartDiscountCodes(cart);

      if (cartAlreadyHasWelcomeCover(cart, selection.parentHandle, selection.coverVariant.id)) {
        selection.existingDiscountCodes = mergeDiscountCodes(selection.existingDiscountCodes, cartDiscountCodes(cart));
        setPreparationStatus('success', 'Your matching 40x40 cover is already in the cart. Taking you to checkout...');
        return selection;
      }

      return addWelcomeCover(selection).then(function () {
        return waitForWelcomeCoverInCart(selection);
      }).then(function (confirmedCart) {
        selection.existingDiscountCodes = mergeDiscountCodes(selection.existingDiscountCodes, cartDiscountCodes(confirmedCart));
        setPreparationStatus('success', 'Matching 40x40 cover added. Taking you to checkout...');
        return selection;
      });
    });
  }

  function welcomeCoverErrorMessage(error) {
    var code = String((error && error.message) || error || '');
    if (code === 'welcome_cover_needs_body_pillow') {
      return 'WELCOMECOVER needs a body pillow design in the cart first, so we can add the matching 40x40 cover.';
    }
    if (code === 'missing_cover_variant') {
      return 'This design does not have a matching 40x40 welcome cover ready yet. Please choose another body pillow design or contact support.';
    }
    if (code === 'welcome_cover_add_unconfirmed') {
      return 'The free matching cover could not be confirmed in the cart. Please reload the cart and try again.';
    }
    return 'The free matching cover could not be added. Please reload the cart and try again.';
  }

  function welcomeCoverAutoApplyAlreadyAttempted() {
    return welcomeCoverAutoApplyAttempted || sessionStorageGet(WELCOME_COVER_AUTO_APPLY_KEY) === 'true';
  }

  function markWelcomeCoverAutoApplyAttempted() {
    welcomeCoverAutoApplyAttempted = true;
    sessionStorageSet(WELCOME_COVER_AUTO_APPLY_KEY, 'true');
  }

  function welcomeCoverAutoApplyForm() {
    var form = document.querySelector('[data-fbp-addon-discount-form][data-fbp-welcome-cover-auto-apply="true"]');
    if (form) return form;
    if (window.__fbpWelcomeCoverAutoApply === true || window.__fbpWelcomeCoverAutoApply === 'true') {
      return document.querySelector('[data-fbp-addon-discount-form]');
    }
    return null;
  }

  function autoApplyWelcomeCoverIfEligible() {
    if (welcomeCoverAutoApplyInFlight || welcomeCoverAutoApplyAlreadyAttempted()) return;

    var form = welcomeCoverAutoApplyForm();
    if (!form) return;

    var navigation = beginWelcomeCoverNavigation('auto');
    if (!navigation) return;
    welcomeCoverAutoApplyInFlight = true;

    fetchCart().then(function (cart) {
      if (!ownsWelcomeCoverNavigation(navigation) || !cartHasPotentialDaki(cart) || cartHasWelcomeCoverLine(cart)) {
        welcomeCoverAutoApplyInFlight = false;
        releaseWelcomeCoverNavigation(navigation);
        return null;
      }

      markWelcomeCoverAutoApplyAttempted();
      return prepareWelcomeCoverGift(form).then(function (selection) {
        if (!ownsWelcomeCoverNavigation(navigation)) return null;
        navigateWelcomeCover(navigation, cartDiscountUrl([WELCOME_COVER_CODE], true));
        return null;
      });
    }).catch(function () {
      welcomeCoverAutoApplyInFlight = false;
      if (!ownsWelcomeCoverNavigation(navigation)) return;
      markWelcomeCoverAutoApplyAttempted();
      releaseWelcomeCoverNavigation(navigation);
      setWelcomeCoverStatus(form, 'error', 'We could not confirm your welcome cover automatically. Reload the cart to check it before trying WELCOMECOVER again.');
    });
  }

  function scheduleWelcomeCoverAutoApply() {
    if (welcomeCoverAutoApplyTimer || welcomeCoverAutoApplyInFlight || welcomeCoverAutoApplyAlreadyAttempted()) return;
    welcomeCoverAutoApplyTimer = window.setTimeout(function () {
      welcomeCoverAutoApplyTimer = null;
      autoApplyWelcomeCoverIfEligible();
    }, 250);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isAddonDiscountForm(form)) return;
    var checkoutButton = checkoutButtonFromEvent(event);
    if (!checkoutButton) {
      if (!manualDiscountCodeForForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      applyDiscountFromCartControl(form, form.querySelector('[data-fbp-apply-discount]') || form.querySelector('[name="discount"]'));
      return;
    }

    var codes = activeDiscountCodesForForm(form);
    var navigation = beginWelcomeCoverNavigation('checkout');
    if (!navigation) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!codes.length) {
      navigation.kind = 'native-checkout';
      return; // Preserve the native checkout submission and cancel stale auto redirects.
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!hasDiscountCode(codes, WELCOME_COVER_CODE)) {
      navigateWelcomeCover(navigation, checkoutDiscountUrl(codes));
      return;
    }

    if (welcomeCoverSubmitInFlight) return;
    welcomeCoverSubmitInFlight = true;
    setCheckoutBusy(checkoutButton, true);

    withTimeout(prepareWelcomeCoverGift(form), WELCOME_COVER_TIMEOUT_MS, 'welcome_cover_timeout').then(function () {
      navigateWelcomeCover(navigation, checkoutDiscountUrl([WELCOME_COVER_CODE]));
    }).catch(function (error) {
      welcomeCoverSubmitInFlight = false;
      if (!ownsWelcomeCoverNavigation(navigation)) return;
      navigation.failed = true;
      setWelcomeCoverStatus(form, 'error', welcomeCoverErrorMessage(error) + ' Opening checkout now so your order is not blocked.');
      window.setTimeout(function () {
        navigateWelcomeCover(navigation, checkoutDiscountUrl(codes));
      }, 900);
    });
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('.send-icon, [data-fbp-apply-discount]');
    if (!target) return;

    var form = target.closest('[data-fbp-addon-discount-form]');
    if (!isAddonDiscountForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    applyDiscountFromCartControl(form, target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-fbp-addon-discount-form] [name="discount"]')) return;

    var form = input.closest('[data-fbp-addon-discount-form]');
    if (!isAddonDiscountForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    applyDiscountFromCartControl(form, input);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleWelcomeCoverAutoApply);
  } else {
    scheduleWelcomeCoverAutoApply();
  }

  if (window.MutationObserver) {
    var welcomeCoverAutoApplyObserver = new MutationObserver(function () {
      if (welcomeCoverAutoApplyForm()) scheduleWelcomeCoverAutoApply();
    });
    welcomeCoverAutoApplyObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-fbp-welcome-cover-auto-apply'],
      childList: true,
      subtree: true
    });
  }
})();
